import * as React from 'react';
import { UserMessage, UserMessageType } from 'app/types-shared';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { deepEquals } from 'app/infrastructure/js';
import { MdClose } from 'react-icons/md';
import { Link } from 'ui';
import { ToastPosition } from 'ui/constants';
import styles from 'app/infrastructure/notifications/toast-factory.scss';

interface MessageProps {
  messages: UserMessage[];
}

const CustomCloseButton = (toastProps: any) => {
  const { ...validProps } = toastProps;
  return <MdClose {...validProps} className={styles.customCloseButton} />;
};

export class MessagePanel extends React.PureComponent<MessageProps> {
  public componentDidUpdate(prevProps: MessageProps) {
    const { messages: currentMessages } = prevProps;
    const { messages: pendingMessages = [] } = this.props;

    if (
      deepEquals(currentMessages, pendingMessages) ||
      !pendingMessages.length
    ) {
      return;
    }

    pendingMessages.forEach(message => toast.dismiss(message.id));

    const icon = () => <CustomCloseButton size={22} />;

    pendingMessages
      .filter(m => currentMessages.indexOf(m) === -1)
      .forEach(m => {
        const mgs = (
          <div>
            {m.title && <div className={styles.toastTitle}>{m.title}</div>}
            {m.link
              ? <Link url={m.link} linkText={m.message}><div className={styles.link}>{m.message}</div></Link>
              : <div>{m.message}</div>}
          </div>
        );

        if (m.type === UserMessageType.success) {
          toast.success(mgs, {
            position: ToastPosition.TOP_LEFT,
            closeButton: icon,
            className: `${styles.toastContainer} ${styles.successToast}`,
            bodyClassName: styles.toastBody,
            progressClassName: styles.successToastProgress
          });
        }
        if (m.type === UserMessageType.error) {
          toast.error(mgs, {
            position: ToastPosition.TOP_LEFT,
            closeButton: icon,
            className: `${styles.toastContainer} ${styles.errorToast}`,
            bodyClassName: styles.toastBody,
            progressClassName: styles.errorToastProgress
          });
        }
        if (m.type === UserMessageType.info) {
          toast.info(mgs, {
            position: ToastPosition.TOP_LEFT,
            closeButton: icon,
            className: `${styles.toastContainer} ${styles.infoToast}`,
            bodyClassName: styles.toastBody,
            progressClassName: styles.infoToastProgress
          });
        }
      });
  }

  public componentWillUnmount() {
    const { messages = [] } = this.props;
    messages.forEach(message => toast.dismiss(message.id));
  }

  public render() {

    return <ToastContainer
      position={ToastPosition.TOP_LEFT}
      style={{ zIndex: 2001 }}
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      className={styles.toastContainer}
      toastClassName={styles.body}
      closeOnClick={true}
      pauseOnHover
      theme="colored"
      icon={false}
    />;
  }
}
